import { render, staticRenderFns } from "./ChangeTeamItem.vue?vue&type=template&id=122b37e4"
import script from "./ChangeTeamItem.vue?vue&type=script&lang=ts"
export * from "./ChangeTeamItem.vue?vue&type=script&lang=ts"
import style0 from "./ChangeTeamItem.vue?vue&type=style&index=0&id=122b37e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports